import * as Sentry from '@sentry/nextjs';
import BlogPosts from 'components/blog/BlogPosts';

import Layout from 'components/layout';
import { getAllPosts, getCategories } from 'lib/api/posts';
import PropTypes from 'prop-types';
import { BLOG_CATEGORIES } from 'utilities/blog';
import { BlogPostTileType } from 'utilities/propTypes';

const REVALIDATE_TIME_MINUTES = 5;
const REVALIDATE_TIME_SECONDS = REVALIDATE_TIME_MINUTES * 60;

export const getStaticProps = Sentry.wrapGetStaticPropsWithSentry(
  async ({ params }) => {
    const { category } = params;
    const posts = await getAllPosts({ category });
    if (posts.length === 0) {
      return {
        notFound: true,
      };
    }
    return {
      props: {
        posts,
        category,
      },
      revalidate: REVALIDATE_TIME_SECONDS,
    };
  }
);

export const getStaticPaths = async () => {
  const categoriesWithPosts = await getCategories({});
  const paths = categoriesWithPosts.map((category) => {
    return {
      params: {
        category,
      },
    };
  });

  return {
    paths,
    fallback: 'blocking',
  };
};

export default function CategoryPage({ posts, category }) {
  const strings = BLOG_CATEGORIES[category];

  // If the the category is not in the BLOG_CATEGORIES object, this will fail.
  const [heading, body] = strings;
  return (
    <Layout
      title="Resistbot News"
      description="Opinion articles from our volunteers and news about Resistbot features."
    >
      <div className={'mb-1'}>
        <h2>{heading}</h2>
        <div>{body}</div>
      </div>
      <BlogPosts posts={posts}></BlogPosts>
    </Layout>
  );
}

CategoryPage.propTypes = {
  posts: PropTypes.arrayOf(BlogPostTileType).isRequired,
  category: PropTypes.oneOf(['national', 'resistbot', 'state', 'podcast'])
    .isRequired,
};
